import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-column brand-column">
            <h2 className="footer-logo">The Claw Gen</h2>
            <p className="footer-tagline">
              Forging the future of intelligent workflows and AI-driven growth.
            </p>
          </div>

          {/* Navigation Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Product</h3>
            <ul className="footer-links">
              <li><a href="#features">Features</a></li>
              <li><a href="#how-it-works">How it Works</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#modules">Modules</a></li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              <li><a href="#about">About</a></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Social Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Follow</h3>
            <div className="footer-socials">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">GitHub</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} The Claw Gen. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
